import { ErrorMessages } from "@/shared/common/enums";
import type { ValidationSchemaProps } from "@/shared/common/types";
import * as Yup from "yup";

export const loginValidationSchema = ({ t }: ValidationSchemaProps) => Yup.object().shape({
  userName: Yup.string().required(t(ErrorMessages.RequiredField)),
  password: Yup.string().required(t(ErrorMessages.RequiredField)),
});

export const resetWithCardNumberValidationSchema = ({ t }: ValidationSchemaProps) =>
  Yup.object().shape({
    cardNumber: Yup.string()
      .required(t(ErrorMessages.RequiredField))
      .length(19, t("errorMessages.cardNumberMustBe", { count: 16 })),
  });

export const resetWithAccountNumberValidationSchema = ({ t }: ValidationSchemaProps) =>
  Yup.object().shape({
    accountNumber: Yup.string()
      .required(t(ErrorMessages.RequiredField))
      .matches(/^\d+$/, t("errorMessages.accountNumberMustContainOnlyNumbers"))
      .length(16, t("errorMessages.accountNumberMustBe", { count: 16 })),
  });

export const newPasswordValidationSchema = ({ t }: ValidationSchemaProps) => Yup.object().shape({
  password: Yup.string().required(t(ErrorMessages.RequiredField))
    .min(8, t("errorMessages.passwordMustBe", { count: 8 }))
    .max(20, t("errorMessages.passwordCannotExceed", { count: 20 }))
    .matches(/[a-z]/, t("errorMessages.passwordMustContainLowercase"))
    .matches(/[A-Z]/, t("errorMessages.passwordMustContainUppercase"))
    .matches(/\d/, t("errorMessages.passwordMustContainNumber"))
    .matches(
      /[@$!%*.?&#]/,
      t("errorMessages.passwordMustContainSymbol", { symbols: "(@$!%*.?&#)" })
    ),
  confirmPassword: Yup.string().when("password", {
    is: (password: string) => !!password,
    then: (schema) =>
      schema.oneOf([Yup.ref("password")], t("errorMessages.passwordsMustMatch")),
    otherwise: (schema) =>
      schema.required(t(ErrorMessages.RequiredField)),
  }),
});

export const usernameVerificationValidationSchema = ({ t }: ValidationSchemaProps) =>
  Yup.object().shape({
    username: Yup.string().required(t(ErrorMessages.RequiredField)),
  });
